import React, { useState } from "react";
import "./GiftModal.css"; // Ensure the CSS file is properly linked

const GiftModal = ({ isOpen, onClose, scheme, gifts }) => {
  const [zoomedImage, setZoomedImage] = useState(null);

  if (!isOpen || !scheme || !gifts.length) return null;

  // Assuming the base category value
  const baseCategoryValue = 5000;
  const categories = [
    ...new Set(gifts.map((gift) => parseInt(gift.category))),
  ].sort((a, b) => a - b);

  const handleImageClick = (photo_link) => {
    setZoomedImage(photo_link);
  };

  // Function to close the zoomed image without closing the modal
  const closeZoomedImage = (e) => {
    e.stopPropagation(); // Prevent the modal from closing
    setZoomedImage(null);
  };

  return (
    <div className="gift-modal-overlay" onClick={onClose}>
      <div className="gift-modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>Gifts for {scheme.productInfo.brand_name}</h2>
        {categories.map((category, index) => {
          // Calculate the required quantity for this category
          const requiredQty = Math.round(
            scheme[1] * (category / baseCategoryValue)
          );
          return (
            <div key={index} className="category-section">
              <h3>
                Buy {requiredQty} {scheme.productInfo.unit} and get 1 gift from
                below:
              </h3>
              <div className="gifts-for-category">
                {gifts
                  .filter((gift) => parseInt(gift.category) === category)
                  .map((gift, giftIndex) => (
                    <div
                      key={giftIndex}
                      className="gift-item"
                      onClick={() => handleImageClick(gift.photo_link)}
                    >
                      <img
                        src={gift.photo_link}
                        alt={gift.gift_name}
                        className="gift-image"
                      />
                      <div className="gift-description">
                        <p>{`Buy ${requiredQty} ${scheme.productInfo.unit} of ${scheme.productInfo.brand_name} and get :`}</p>
                        <h4>
                          <strong>{gift.gift_name}</strong>
                        </h4>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          );
        })}
        <button onClick={onClose}>Close</button>
      </div>
      {zoomedImage && (
        <div className="zoomed-image-overlay" onClick={closeZoomedImage}>
          <img
            src={zoomedImage}
            alt="Zoomed Gift"
            className="zoomed-in-image"
          />
        </div>
      )}
    </div>
  );
};

export default GiftModal;
